import * as Polyfill from '../../components/polyfill';
import { Unsubscribe } from './page';

Polyfill.init();
new Unsubscribe(document.querySelector('body')).init();
